import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { mainModuleName, rolesModuleName } from '@piqet-angular/shared';

@Injectable({
  providedIn: 'root',
})
export class AccessPermissionService {
  private administratorProjects = 'admin-projects';

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {}

  // For project module
  public isAccess(pathName: string, type?: string) {
    return pathName === 'admin-projects'
      ? this.getRolesAndPermission(
          rolesModuleName.AdministratorProjects,
          mainModuleName.projectManagementModule
        )
      : this.getRolesAndPermission(
          type ? rolesModuleName.packageScenario : rolesModuleName.productScenario,
          type ? mainModuleName.projectsModule : mainModuleName.productsModule
        );
  }

  private getRolesAndPermission(moduleName: string, parentModuleName: string) {
    const rolesDataJson: string | null = localStorage.getItem('access');
    if (!rolesDataJson) return null;

    const rolesDataParse = JSON.parse(rolesDataJson);

    return rolesDataParse?.find(
      (data: any) =>
        data.moduleName === moduleName &&
        data.parentModuleName === parentModuleName &&
        rolesDataParse?.filter(
          (dataParent: any) =>
            dataParent.moduleName === parentModuleName &&
            dataParent.moduleId === data.parentModuleId
        )[0]
    );
  }

  public hasPermission(
    permissionType: 'view' | 'edit' | 'create' | 'delete',
    pathName?: string,
    moduleType?: string
  ): boolean {
    const currentPath = pathName || this.getCurrentPathName();
    const access = this.isAccess(currentPath, moduleType);
    if (permissionType === 'view') {
      return access ? !!access.isView : true;
    }

    if (permissionType === 'edit') {
      return access ? !!access.isEdit : false;
    }

    if (permissionType === 'create') {
      return access ? !!access.isCreate : false;
    }

    if (permissionType === 'delete') {
      return access ? !!access.isDelete : false;
    }

    return false;
  }

  public getCurrentPathName(): string {
    let route = this.activatedRoute;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route.snapshot.url.length > 0 ? route.snapshot.url[0].path : '';
  }

  // For other module
  public hasModulePermission(
    moduleName: string,
    parentModuleName: string,
    permissionType: 'view' | 'edit' | 'create' | 'delete' | 'overview'
  ): boolean {
    const access = this.getModuleAccess(moduleName, parentModuleName);
    switch (permissionType) {
      case 'view':
        return access ? !!access.isView : true;
      case 'edit':
        return access ? !!access.isEdit : false;
      case 'create':
        return access ? !!access.isCreate : false;
      case 'overview':
        return access ? !!access.isOverview : false;
      case 'delete':
        return access ? !!access.isDelete : false;
      default:
        return false;
    }
  }

  private getModuleAccess(moduleName: string, parentModuleName: string): any {
    const rolesDataJson: string | null = localStorage.getItem('access');
    if (!rolesDataJson) return null;

    const rolesDataParse = JSON.parse(rolesDataJson);

    return rolesDataParse?.find(
      (data: any) =>
        data.moduleName.toLowerCase() === moduleName.toLowerCase() &&
        data.parentModuleName.toLowerCase() === parentModuleName.toLowerCase() &&
        rolesDataParse?.filter(
          (dataParent: any) =>
            dataParent.moduleName.toLowerCase() === parentModuleName.toLowerCase() &&
            dataParent.moduleId === data.parentModuleId
        )[0]
    );
  }
}
